export const CRYPTO_CONTEXT = "crypto";
export const KEYCHAIN_CONTEXT = "keychain";
//# sourceMappingURL=crypto.js.map